/**
 *
 * @param {*} px   像素值 string/number
 * @param {*} times 倍数 如三倍图则传3  number
 */
export function pixelToVW(px, times = 3) {
    return `${(+px / times / 375) * 100}vw`;
}
